import { Text } from '@ui/atoms';

import { whyFds } from '@components/Products/FixedDeposits/utils/helper';
import FDWhyStep from '@components/Products/FixedDeposits/components/Benefits/FDWhyStep';

const FixedDepositsBenefits = () => {
    return (
        <section className="py-3 px-4 max-w-[1082px] w-full mx-auto md:py-18 flex flex-col gap-4 md:gap-8 xl:px-0">
            <Text
                content={whyFds.title}
                className="text-center p3-regular md:h3-regular"
                isInnerHtml
                htmlTag='h2'
            />
            <ul className="flex flex-col gap-6 mx-auto md:gap-8 md:flex-row md:flex-wrap md:justify-center">
                {whyFds.steps.map((step) => (
                    <li key={step.title}>
                        <FDWhyStep step={step} />
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default FixedDepositsBenefits;
